export default __webpack_public_path__ + "static/lysicrates-donation-background-e96ae385f2722860b0db4d53ce11df19.png";